import Icon from '@ant-design/icons';
import * as React from 'react';

const ActivitySvg = (props: any) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
  </svg>
);

export const ActivityIcon = (props) => (
  <Icon component={ActivitySvg} {...props} />
);
